import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'DeFi Integrations',
    assets: 'Assets',
    protocol: 'Protocol',
    network: 'Network',
    iota: 'IOTA',
    poolsFinance: 'Pools Finance',
    virtueFinance: 'Virtue Finance',
    VUSDCDPType: 'VUSD CDP',
    farmingType: 'Farming',
    liquidityPoolType: 'Liquidity pool',
  },
};
